/* RESPONSIBLE TEAM: team-inbox */
import ApplicationAdapter from './application';
import { inject as service } from '@ember/service';

export default class SavedReplyAdapter extends ApplicationAdapter {
  @service declare appService: any;

  get useInboxEndpoint(): boolean {
    return !!this.appService?.app?.canUseFeature('team-inbox-ensure-inbox-macros-correct-endpoint');
  }

  /**
   * Route findAll/findRecord to the inbox endpoint when flag is ON.
   * This is used by the Inbox/Composer context (store.findAll).
   */
  pathForType(): string {
    if (this.useInboxEndpoint) {
      return 'inbox/saved_replies';
    }
    return 'saved_replies';
  }

  urlForQuery(): string {
    return `/${this.namespace}/saved_replies`;
  }

  // Keep write operations on the old /ember/saved_replies endpoint
  urlForCreateRecord(): string {
    return `/${this.namespace}/saved_replies`;
  }

  urlForUpdateRecord(id: string | number): string {
    return `/${this.namespace}/saved_replies/${id}`;
  }

  urlForDeleteRecord(id: string | number): string {
    return `/${this.namespace}/saved_replies/${id}`;
  }
}
